module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-2-472e76ae2ee5e6db8799d695637936f5.png";